import React from 'react'
import { Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { ModalBoxProps } from './ModalBox.types'
import { ModalBoxDialog, ModalBoxWrapper } from './ModalBox.styles'
import useId from '../../hooks/useId'

const TransitionBottom = React.forwardRef(
  (
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
  ) => <Slide direction="up" ref={ref} {...props} />
)

const TransitionTop = React.forwardRef(
  (
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
  ) => <Slide direction="down" ref={ref} {...props} />
)

const ModalBox = ({
  className = '',
  open = false,
  styles,
  children,
  align = 'center',
  data,
  closeActions,
  'data-testid': testid = 'modal',
  ...props
}: ModalBoxProps) => {
  const { getTestId } = useId(testid)
  const handleClose = () => {
    if (closeActions) {
      closeActions({ data })
    }
  }
  return (
    <ModalBoxDialog
      className={`ModalBox ${className}`}
      open={open}
      align={align}
      sx={styles}
      onClose={handleClose}
      TransitionComponent={align === 'top' ? TransitionTop : TransitionBottom}
      keepMounted
      data-testid={getTestId()}
      {...props}>
      <ModalBoxWrapper className="ModalBoxWrapper" align={align} {...props}>
        {children}
      </ModalBoxWrapper>
    </ModalBoxDialog>
  )
}

TransitionBottom.displayName = 'TransitionBottom'
TransitionTop.displayName = 'TransitionTop'
export default ModalBox
